import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import ChoiceField from '../common/ChoiceField';
import EventForm from './EventForm';
import AwayTimeForm from './AwayTimeForm';

const categories = [
  {
    label: '☕️ Marketing & Meeting Time',
    value: 'ADMIN_TIME',
    description: 'Team meetings, marketing activities',
    xs: 12,
    md: 6,
    lg: 6,
    align: 'left',
  },
  {
    label: '✈️ Away Time',
    value: 'AWAY_TIME',
    description: 'Vacation, PTO, out of office',
    xs: 12,
    md: 6,
    lg: 6,
    align: 'left',
  },
];

const BlockTimeForm = (props) => {
  const [eventCategory, setEventCategory] = useState('ADMIN_TIME');
  return (
    <Box style={{width: '100%'}}>
      <Stack style={{width: '100%'}} spacing={4}>
        <ChoiceField
          label='Category'
          value={eventCategory}
          defaultValue='ADMIN_TIME'
          onChange={e => setEventCategory(e.target.value)}
          options={categories}
          choiceStyle='card'
        />
      {eventCategory === 'ADMIN_TIME' &&
        <EventForm
          isEditing={false}
          onSuccess={props.onSuccess}
        />
      }
      {
        eventCategory === 'AWAY_TIME' &&
        <AwayTimeForm
          onSuccess={props.onSuccess}
        />
      }
      </Stack>
    </Box>
  );
};

export default BlockTimeForm;